/**
 * @generated SignedSource<<3cfe4c229b016b8f8d5c82d1fda8103a>>
 * @relayHash 185b3ec95506eb90d87d9c6598d02bc6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3b91b137e619be9a70d6c6e174b8992ea11fec1d8d33316320e6f844e6ac93ee

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RecommendedAgentResultsQuery$variables = {
  cloudId: string;
  cloudIdString: string;
  contextAri: string;
  first?: number | null;
  templateProduct?: string | null;
  useJiraRecommended: boolean;
};
export type RecommendedAgentResultsQuery$data = {
  readonly agentStudio_getAllTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly previewRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateView_StudioBrowseKit">;
        };
        readonly templateRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateCard_StudioBrowseKit">;
        };
      } | null;
    } | null> | null;
  } | null;
  readonly jira?: {
    readonly jira_recommendedAgentsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agent?: {
            readonly agentRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
            } | null;
            readonly deactivated?: boolean | null;
            readonly heroRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentHeroCard_StudioBrowseKit">;
            } | null;
            readonly id?: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type RecommendedAgentResultsQuery = {
  response: RecommendedAgentResultsQuery$data;
  variables: RecommendedAgentResultsQuery$variables;
};
({
  "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isUpliftEnabled_provider from '@atlassian/studio-browse-kit/ui/agent-card/components/isAgentAuthorUpliftEnabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateProduct"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useJiraRecommended"
},
v6 = [
  {
    "kind": "Literal",
    "name": "assignableOnly",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "contextAri",
    "variableName": "contextAri"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "includeSemanticallyAvailable",
    "value": false
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "deactivated"
},
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "templateProduct"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "description"
},
v13 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RecommendedAgentResultsQuery",
    "selections": [
      {
        "condition": "useJiraRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraActorConnection",
                "kind": "LinkedField",
                "name": "jira_recommendedAgentsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraActorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "fragment": {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "kind": "FragmentSpread",
                                              "name": "AgentCardRelay_StudioBrowseKit"
                                            }
                                          ],
                                          "type": "AgentStudioAssistant"
                                        },
                                        "kind": "AliasedInlineFragmentSpread",
                                        "name": "agentRef"
                                      },
                                      {
                                        "fragment": {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "kind": "FragmentSpread",
                                              "name": "AgentHeroCard_StudioBrowseKit"
                                            }
                                          ],
                                          "type": "AgentStudioAssistant"
                                        },
                                        "kind": "AliasedInlineFragmentSpread",
                                        "name": "heroRef"
                                      }
                                    ],
                                    "type": "AgentStudioAssistant"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAgenticUser"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateCard_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "templateRef"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateView_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "previewRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "RecommendedAgentResultsQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "avatarUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "usageCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "templateAppKeys"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "executionTier"
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateSupportedTrigger",
                    "kind": "LinkedField",
                    "name": "supportedTriggers",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateHowItWorksStep",
                    "kind": "LinkedField",
                    "name": "howItWorks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "role"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "useJiraRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraActorConnection",
                "kind": "LinkedField",
                "name": "jira_recommendedAgentsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraActorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "isVerified"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "icon"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalConfigReference"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "identityAccountId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "identityAccount",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isUser"
                                          },
                                          (v13/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "appType"
                                              }
                                            ],
                                            "type": "AppUser"
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "creatorType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "forgeCreator"
                                      },
                                      {
                                        "concreteType": "TeamV2",
                                        "kind": "LinkedField",
                                        "name": "authoringTeam",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "accountStatus"
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              (v13/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "accountId"
                                              }
                                            ]
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "AgentStudioAssistant"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAgenticUser"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3b91b137e619be9a70d6c6e174b8992ea11fec1d8d33316320e6f844e6ac93ee",
    "metadata": {},
    "name": "RecommendedAgentResultsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianstudiobrowsekituiagentcardcomponentsisAgentAuthorUpliftEnabledrelayprovider": isUpliftEnabled_provider
    }
  }
};
})();

(node as any).hash = "63bd15eec3c1fb036e9321887e414838";

export default node;
